import { yearRegex } from './regexes';

export const getEnumKeyFromValue = (obj: Object, value: string | number) => {
  return Object.keys(obj).find(k => obj[k] === value);
};

export const getSelectedObjectiveGoalsYear = () => {
  const value = localStorage.getItem('selectedObjectiveSettingYear');

  if (yearRegex.test(String(value))) {
    return +value!;
  }

  return new Date().getFullYear();
};
